// src/components/JourneyPlanner.js
import React, { useState, useEffect } from 'react';

const JourneyPlanner = ({ from, to }) => {
  const [journeys, setJourneys] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchJourneys = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(`http://localhost:3001/api/journey/${from}/${to}`);
        if (!response.ok) throw new Error('Journey data could not be fetched!');
        const data = await response.json();
        setJourneys(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (from && to) fetchJourneys();
  }, [from, to]);

  if (loading) return <p>Searching for trains from {from} to {to}...</p>;
  if (error) return <p>Error: {error}</p>;

  // ... same JSX table as before to display results ...
  return (
    <div className="journey-planner">
      <h2>Trains from {from} to {to}</h2>
      {journeys.length > 0 ? (
         <table>
          <thead>
            <tr>
              <th>Departs</th>
              <th>Arrives</th>
              <th>Platform</th>
              <th>Expected</th>
              <th>Final Destination</th>
            </tr>
          </thead>
          <tbody>
            {journeys.map((journey) => (
              <tr key={journey.id}>
                <td>{journey.departsAt}</td>
                <td>{journey.arrivesAt}</td>
                <td>{journey.platform}</td>
                <td style={{ color: journey.expected !== 'On time' ? '#e74c3c' : '#2ecc71' }}>
                  {journey.expected}
                </td>
                <td>{journey.destinationName}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No direct services found for this journey at this time.</p>
      )}
    </div>
  );
};

export default JourneyPlanner;